import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <div className='footer'>
      <div className='footer_text'>
        <h2>جميع الحقوق محفوظه لدي صَيّن</h2>
      </div>
      <div className='icons' >
        <a href='https://www.facebook.com/profile.php?id=61563254912436'><i className="ri-facebook-circle-fill fes"></i></a>
        <a href='https://wa.me/201000375056'><i className="ri-whatsapp-line"></i></a>
      
      </div>
    </div>
  )
}

export default Footer
